import { TFunction } from 'i18next';

export const getAppendix = ({
  count,
  onlyCount,
}: {
  count: number;
  onlyCount?: boolean;
  translator: TFunction<'translation', undefined>;
}): string => {
  if (count === 0) return `${count} ${onlyCount ? 'Vybraných' : ''} položek`;
  if (count === 1) return `${count} ${onlyCount ? 'Vybraná' : ''} položka`;
  if (count <= 4) return `${count} ${onlyCount ? 'Vybrané' : ''} položky`;
  return `${count} ${onlyCount ? 'Vybraných' : ''} položek`;
};
